import axios from "axios";
import { PASSWORDS_BY_TOKEN_URL, FORGOT_PASSWORDS_URL, RESET_PASSWORDS_URL } from "../../config";
import { routes } from "../constants/routes";
import { history } from "../helpers/history";
import {
    infoEmailToast, infoResetPasswordToast,
} from "../components/Toast";

/**
 * Przypominanie hasła.
 * 
 * Do żądania sieciowego wysyłamy dane użytkownika (email), i w odpowiedzi dostajemy:
 * 
 *  - status 202 - Żądanie zostało zaakceptowane do przetworzenia, ale przetwarzanie nie zostało zakończone. Żądanie może, ale nie musi, zostać zrealizowane, ponieważ może zostać odrzucone, gdy przetwarzanie faktycznie ma miejsce
 *
 * @param {object} forgotPassword obiekt do przypominania hasła (email)
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const doForgotPassword = (forgotPassword, callback) => {
    return dispatch => {
        return axios
            .post(`${FORGOT_PASSWORDS_URL}`, JSON.stringify(forgotPassword), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {

                //przekierowujemy na home
                history.push(routes.HOME);

                //toast on success
                infoEmailToast(forgotPassword.email);
            })
            .then(() => callback && callback());
    };
};

/**
 * Resetowanie hasła.
 * 
 * Do żądania sieciowego wysyłamy dane użytkownika (nowe hasło i token), i w odpowiedzi dostajemy:
 * 
 *  - status 202 - Żądanie zostało zaakceptowane do przetworzenia, ale przetwarzanie nie zostało zakończone. Żądanie może, ale nie musi, zostać zrealizowane, ponieważ może zostać odrzucone, gdy przetwarzanie faktycznie ma miejsce
 *
 * @param {object} resetPassword obiekt do przypominania hasła (email)
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const doResetPassword = (resetPassword, callback) => {
    return dispatch => {
        return axios
            .post(`${RESET_PASSWORDS_URL}`, JSON.stringify(resetPassword), {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {

                //toast on success
                infoResetPasswordToast();

                //przekierowujemy na home
                history.push(routes.HOME);
            })
            .then(() => callback && callback());
    };
};

/**
 * Resetowanie hasła.
 * 
 * Do żądania sieciowego wysyłamy dane użytkownika (nowe hasło i token), i w odpowiedzi dostajemy:
 * 
 *  - status 202 - Żądanie zostało zaakceptowane do przetworzenia, ale przetwarzanie nie zostało zakończone. Żądanie może, ale nie musi, zostać zrealizowane, ponieważ może zostać odrzucone, gdy przetwarzanie faktycznie ma miejsce
 *
 * @param {object} resetPassword obiekt do przypominania hasła (email)
 * @param {function} callback funkcja zwrotna, wywołana po pomyślnym wywołaniu żądania sieciowego
 */
export const doFetchToken = (token, callback) => {
    return dispatch => {
        return axios
            .get(`${PASSWORDS_BY_TOKEN_URL}`, {
                params: {
                    token: token
                }
            }, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                //jesli OK, nic nie robimy
            })
            .then(() => callback && callback())
            .catch(error => {
                // Do something with response error
                // jeśli błąd tokena - przedawniony lub już użyty
                if (error.response.status === 409) {
                    //przekierowujemy na home
                    history.push(routes.HOME);
                }
                // jeśli token nie istnieje
                if (error.response.status === 404) {
                    //przekierowujemy na home
                    history.push(routes.HOME);
                }
            })
            ;
    };
};